export default class JobType {
	static readonly ROUTINE = 0;
	static readonly STAT = 1;
}
